import {
  AtSign,
  Box,
  Globe,
  Hash,
  Mail,
  MapPin,
  Server,
  SquareCheck,
  Ticket,
  TriangleAlert,
  User,
  type LucideIcon,
} from 'lucide-react';

/* Единая карта «тип сущности → иконка» для чипов, вкладок рабочего стола и результатов поиска. */
export type EntityKind =
  | 'host'
  | 'vm'
  | 'location'
  | 'user'
  | 'channel'
  | 'ticket'
  | 'incident'
  | 'mail'
  | 'task'
  | 'account'
  | 'mention';

const icons: Record<EntityKind, LucideIcon> = {
  host: Server,
  vm: Box,
  location: MapPin,
  user: User,
  channel: Hash,
  ticket: Ticket,
  incident: TriangleAlert,
  mail: Mail,
  task: SquareCheck,
  account: Globe,
  mention: AtSign,
};

export function EntityChipIcon({ kind, className }: { kind: EntityKind; className?: string }) {
  const Icon = icons[kind];
  return <Icon className={className} aria-hidden />;
}
